<!--
  核销员列表
-->
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">订单管理</el-breadcrumb-item>
      <el-breadcrumb-item>订单列表</el-breadcrumb-item>
    </el-breadcrumb>
    <el-container>
      <el-main>
        <!-- 搜索筛选 -->
        <el-form :inline="true" label-position="right" label-width="90px" ref="formInline" :model="formInline" class="user-search">
          <el-form-item label="订单号" prop="orderNum">
            <el-input size="small" style="width: 200px;" v-model="formInline.orderNum" placeholder="订单号"></el-input>
          </el-form-item>

          <el-form-item label="用户ID" prop="userId">
            <el-input size="small" style="width: 200px;" v-model="formInline.userId" placeholder="用户ID"></el-input>
          </el-form-item>

          <el-form-item label="所属展会" prop="exhibitionId">
            <el-select v-model="formInline.exhibitionId" placeholder="请选择"  style="height: 33px;width: 250px;">
              <el-option
                v-for="item in exhList"
                :key="item.id"
                :label="item.exhibitionName"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="所属分类" prop="typeId">
            <el-select v-model="formInline.typeId" placeholder="请选择"  style="height: 33px;width: 250px;">
              <el-option
                v-for="item in typeSelect"
                :key="item.value"
                :label="item.name"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="联系人" prop="linkman">
            <el-input size="small" style="width: 200px;" v-model="formInline.linkman" placeholder="联系人"></el-input>
          </el-form-item>
          <el-form-item label="联系电话" prop="linkPhone">
            <el-input size="small" style="width: 200px;" v-model="formInline.linkPhone" placeholder="联系电话"></el-input>
          </el-form-item>

          <el-form-item label="状态" prop="status">
            <el-select v-model="formInline.status" placeholder="请选择"  style="height: 33px;width: 250px;">
              <el-option
                v-for="item in statusSelect"
                :key="item.value"
                :label="item.name"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item>
            <el-button size="small" type="primary"  @click="resetFrom" >重置</el-button>
            <el-button size="small" type="primary" icon="el-icon-search" @click="tableList" >搜索</el-button>
            <el-button @click="importExcel()"  size="small" type="primary">导出</el-button>
          </el-form-item>
        </el-form>


        <!--列表-->
        <el-table size="small" :header-cell-style="{background:'#eef1f6',color:'#606266'}":data="listData"
                  highlight-current-row v-loading="loading" border
                  element-loading-text="拼命加载中" style="width: 100%;">

          <el-table-column prop="userId" label="用户ID" align="center"></el-table-column>
          <el-table-column prop="orderNum" label="订单号" align="center"></el-table-column>
          <el-table-column prop="linkman" label="联系人" align="center"></el-table-column>
          <el-table-column prop="linkPhone" label="联系电话" align="center"></el-table-column>
          <el-table-column prop="typeId" label="所属大类" align="center">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.typeId==1">服务类</el-tag>
              <el-tag type="danger" v-if="scope.row.typeId==2">工程类</el-tag>
              <el-tag type="info" v-if="scope.row.typeId==3">餐饮类</el-tag>
              <el-tag v-if="scope.row.typeId==4">租赁类</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="orderDetails" label="购买数量" align="center">
            <template slot-scope="scope">
              <b>{{scope.row.orderDetails.length}}</b>
            </template>
          </el-table-column>
          <el-table-column prop="price" label="实际支付" align="center"></el-table-column>
          <el-table-column prop="boothNumber" label="展位号" align="center"></el-table-column>
          <el-table-column prop="remark" label="备注" align="center"></el-table-column>
          <el-table-column prop="exhibitionName" label="展会名称" align="center"></el-table-column>
          <el-table-column prop="status" label="订单状态" align="center">
            <template slot-scope="scope">
              <el-tag type="danger" effect="dark" v-if="scope.row.status==1">待支付</el-tag>
              <el-tag type="danger" effect="dark" v-if="scope.row.status==2">使用中</el-tag>
              <el-tag type="danger" effect="dark" v-if="scope.row.status==3">退押金</el-tag>
              <el-tag type="danger" effect="dark" v-if="scope.row.status==4">已完成</el-tag>
              <el-tag type="danger" effect="dark" v-if="scope.row.status==5">已取消</el-tag>
            </template>
          </el-table-column>

          <el-table-column prop="cashPledgeStatus" label="押金状态" align="center">
            <template slot-scope="scope">
              <el-tag type="danger" effect="dark" v-if="scope.row.cashPledgeStatus==0">正常</el-tag>
              <el-tag type="danger" effect="dark" v-if="scope.row.cashPledgeStatus==1">待检验</el-tag>
              <el-tag type="danger" effect="dark" v-if="scope.row.cashPledgeStatus==2">待审核</el-tag>
              <el-tag type="danger" effect="dark" v-if="scope.row.cashPledgeStatus==3">已退款</el-tag>
              <el-tag type="danger" effect="dark" v-if="scope.row.cashPledgeStatus==4">已拒绝</el-tag>
            </template>
          </el-table-column>

          <el-table-column align="center"  prop="payTime" label="付款时间" >
            <template slot-scope="scope">
              <div>{{scope.row.payTime|timestampToTime}}</div>
            </template>
          </el-table-column>

          <el-table-column  label="操作" align="left" fixed="right">
            <template slot-scope="scope">
              <el-button size="mini" type="warning" @click="handleInFo(scope.row)"style="width: 100px;margin: 1px;">订单详情</el-button>
              <el-button size="mini" type="warning" @click="upOrderStatus(scope.row.id)"style="width: 100px;margin: 1px;" v-if="scope.row.status == 2 && scope.row.price > 0&& scope.row.totalCashPledge > 0">押金退款</el-button>
              <el-button size="mini" type="success" v-if="!scope.row.billNumber" @click="handleFp(scope.row)"style="width: 100px;margin: 1px;">填写发票</el-button>
              <el-button size="mini" type="success" v-if="scope.row.billNumber" @click="handleFp(scope.row)"style="width: 100px;margin: 1px;">修改发票</el-button>
            </template>
          </el-table-column>

        </el-table>
        <!-- 分页组件 -->
        <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>




        <!-- 编辑界面 -->
        <el-dialog :title="title" :visible.sync="editFormVisibleFp" width="35%" @click='closeDialog("edit")':close-on-click-modal="false">
          <el-form label-width="120px" :model="editForm" ref="editForm"  :rules="rules">

            <el-form-item label="发票类型" prop="billType">
              <el-radio v-model="editForm.billType" :label=1>定额</el-radio>
              <el-radio v-model="editForm.billType" :label=2>普票</el-radio>
              <el-radio v-model="editForm.billType" :label=3>专票</el-radio>
            </el-form-item>

            <el-form-item label="金额" prop="billPrice">
              <el-input size="small" v-model="editForm.billPrice" placeholder="金额" :autosize="{ minRows: 2}" style="width: 70%"  auto-complete="off" ></el-input>
            </el-form-item>
            <el-form-item label="发票抬头" prop="billHeader" v-if="editForm.billType != 1">
              <el-input size="small" v-model="editForm.billHeader" placeholder="发票抬头" :autosize="{ minRows: 2}" style="width: 70%"  auto-complete="off" ></el-input>
            </el-form-item>

            <el-form-item label="发票纳税编号" prop="billNumber" v-if="editForm.billType != 1">
              <el-input size="small" v-model="editForm.billNumber" placeholder="发票纳税编号" :autosize="{ minRows: 2}" style="width: 70%"  auto-complete="off" ></el-input>
            </el-form-item>
            <el-form-item label="地址信息" prop="billAddress" v-if="editForm.billType == 3">
              <el-input size="small" v-model="editForm.billAddress" placeholder="地址信息" :autosize="{ minRows: 2}" style="width: 70%"  auto-complete="off" ></el-input>
            </el-form-item>
            <el-form-item label="注册电话" prop="billPhone" v-if="editForm.billType == 3">
              <el-input size="small" v-model="editForm.billPhone" placeholder="注册电话" :autosize="{ minRows: 2}" style="width: 70%"  auto-complete="off" ></el-input>
            </el-form-item>
            <el-form-item label="开户行" prop="openingBank" v-if="editForm.billType == 3">
              <el-input size="small" v-model="editForm.openingBank" placeholder="开户行" :autosize="{ minRows: 2}" style="width: 70%"  auto-complete="off" ></el-input>
            </el-form-item>
            <el-form-item label="银行账号" prop="bankAccount" v-if="editForm.billType == 3">
              <el-input size="small" v-model="editForm.bankAccount" placeholder="银行账号" :autosize="{ minRows: 2}" style="width: 70%"  auto-complete="off" ></el-input>
            </el-form-item>
            <el-form-item label="备注说明" prop="billRemark">
              <el-input size="small" v-model="editForm.billRemark" placeholder="备注说明" :autosize="{ minRows: 2}" style="width: 70%"  auto-complete="off" ></el-input>
            </el-form-item>
            <el-form-item label="收件人" prop="recipients">
              <el-input size="small" v-model="editForm.recipients" placeholder="收件人" :autosize="{ minRows: 2}" style="width: 70%"  auto-complete="off" ></el-input>
            </el-form-item>
            <el-form-item label="收件人电话" prop="recipientsPhone">
              <el-input size="small" v-model="editForm.recipientsPhone" placeholder="收件人电话" :autosize="{ minRows: 2}" style="width: 70%"  auto-complete="off" ></el-input>
            </el-form-item>
            <el-form-item label="收件地址" prop="recipientsAddress">
              <el-input size="small" v-model="editForm.recipientsAddress" placeholder="收件地址" :autosize="{ minRows: 2}" style="width: 70%"  auto-complete="off" ></el-input>
            </el-form-item>
            <el-form-item label="电子邮箱" prop="billEmail">
              <el-input size="small" v-model="editForm.billEmail" placeholder="电子邮箱" :autosize="{ minRows: 2}" style="width: 70%"  auto-complete="off" ></el-input>
            </el-form-item>


          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button size="small" @click='closeDialog("edit")'>取消</el-button>
            <el-button size="small" type="primary" class="title" :loading="loading" :disabled="isDisabled" @click="submitForm('editForm')">保存</el-button>
          </div>
        </el-dialog>


      </el-main>
    </el-container>
  </div>
</template>

<script>


import {downloadOrderExcel, qryOrderList, upOrderStatus,fpOrder} from '../../api/convenience'
import {qryExhibitionList} from '../../api/courseApi'
import {timestampToTime,parseTime} from "../../utils/util";
import Pagination from '../../components/Pagination'
import ElInputNumber from "../../../node_modules/element-ui/packages/input-number/src/input-number.vue";
import {addCommodity, upCommodity} from "../../api/lotteryApi";


export default {
  name: "orderList",
  data() {
    return {
      title:'添加',
      editFormVisible:false,
      editFormVisibleFp:false,
      loading: false, //是显示加载
      isDisabled: false,
      formInline:{
        orderNum:'',
        exhibitionId:'',
        status:'',
        userId:'',
        typeId:'',
        linkman:'',
        linkPhone:'',
        page:1,
        pageSize:10
      },
      listData:[],
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      },
      editForm: {
        id: '',
        billType: '',
        billPrice: '',
        billHeader: '',
        billNumber: '',
        billAddress: '',
        billPhone: '',
        openingBank: '',
        bankAccount: '',
        billRemark: '',
        recipients: '',
        recipientsPhone: '',
        recipientsAddress: '',
        billEmail: '',
      },

      // rules表单验证
      rules: {
        billType: [
          { required: true, message: '必填项不能为空', trigger: 'blur' }
        ],
      },

      exhList:[],
      typeSelect:[{"name":"服务类","value":"1"},
        {"name":"工程类","value":"2"},
        {"name":"餐饮类","value":"3"},
        {"name":"租赁类","value":"4"}],
      statusSelect:[{"name":"待支付","value":"1"},
        {"name":"使用中","value":"2"},
        {"name":"退押金","value":"3"},
        {"name":"已完成","value":"4"},
        {"name":"已取消","value":"5"}]


    }
  },
  mounted() {
    if (this.$route.query.page) {
      this.formInline.page = this.$route.query.page
    }
    this.tableList();
  },
  methods:{
    tableList(){
      this.loading = true;
      qryExhibitionList({pageSize:1000}).then(res => {
        this.exhList = res.data.list;
      })

      qryOrderList(this.formInline).then(res => {
        this.listData = res.data.list;
        this.pageparm.currentPage = this.formInline.page;
        this.pageparm.pageSize = this.formInline.pageSize;
        this.pageparm.total = res.data.total;
        this.loading = false
      })
    },


    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage;
      this.formInline.pageSize = parm.pageSize;
      this.tableList();
    },


    //显示编辑界面
    handleInFo(info) {
      if (info){
        this.$router.push({ path: '/convenience/orderDetail' ,query:{orderInfo:info,page:this.formInline.page}})
      }
    },


    handleFp(info) {
      this.editForm = info
      this.editFormVisibleFp = true
    },

    closeDialog(editData){
      this.$refs['editForm'].resetFields();
      this.baseForm = [];
      this.editFormVisible = false;
      this.editFormVisibleFp = false;
    },

    resetFrom(){
      this.formInline.orderNum = '';
      this.formInline.exhibitionId = '';
      this.formInline.status = '';
      this.formInline.userId = '';
      this.formInline.typeId = '';
      this.formInline.linkman = '';
      this.formInline.linkPhone = '';
      this.formInline.page = 1;
      this.formInline.pageSize = 10;
    },



    upOrderStatus(id){
      this.$confirm('确定要申请退款吗?', '温馨提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        upOrderStatus({id:id}).then(res =>{
          if(res.code==1){
            this.$message({
              type: 'success',
              message: '数据已更新!'
            })
          }else{
            this.$message({
              type: 'info',
              message: res.msg
            })
          }
          this.tableList();
        })
      }).catch(err => {
      })
    },

    importExcel(){
      downloadOrderExcel(this.formInline).then(res=>{
        let blob = new Blob([res], { type: 'application/vnd.ms-excel' })
        // type值看后台格式,有可能是application/x-xls或application/vnd.ms-excel
        let link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        //配置下载的文件名
        link.download = timestampToTime(new Date())+'订单列表.xls'
        link.click()
      });
    },


    // 编辑、添加提交方法
    submitForm(editData) {
      this.isDisabled = true;
      this.$refs[editData].validate(valid => {
        if (valid) {
          if(this.editForm.id!=''){
            fpOrder(this.editForm).then(res =>{
              if (res.code==1) {
                this.editFormVisibleFp = false
                this.$message({
                  type: 'success',
                  message: '数据保存成功！'
                })
                this.tableList(this.formInline)
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
              this.isDisabled = false;
            }).catch(err => {
              this.editFormVisibleFp = false
              this.$message.error('保存失败，请稍后再试！')
              this.isDisabled = false;
            })
          }
          // 请求方法
        } else {
          this.isDisabled = false;
          return false
        }
      })
    },


  },
  //分页组件
  components: {
    ElInputNumber,
    Pagination
  }
}



</script>



<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/convenience/orderList.vue